import { Heading } from "@chakra-ui/layout";
import {
  Tooltip,
  useToast,
  Box,
} from "@chakra-ui/react";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";
import { UserBannerInfo } from "./UserInfoBannerInfo";

import "./UserInfoBanner.css";
import MainPageSection from "components/Layout/MainPageSection";
import { FormattedMessage, useIntl } from "react-intl";
import LoaderSpinner from "components/UIComponents/LoaderSpinner";
import { getCountryCodeForFlag } from "utils/countryMapping";

const UserInfoBanner = () => {
  const ip = useSelector((state: RootState) => state.userIp.userIp);
  const userIpDetails = useSelector((state: RootState) => state.userIpDetails);
  const intl = useIntl();

  const toast = useToast({
    position: "top",
    title: intl.formatMessage({ id: "IpCopiedToastText" }),
    isClosable: true,
    status: "success",
    duration: 1500,
    containerStyle: {
      width: "210px",
      maxWidth: "100%",
    },
  });

  // Get country code for flag from userIpDetails or userIpData
  const countryCode = userIpDetails?.country || "";
  const flagCode = countryCode ? getCountryCodeForFlag(countryCode) : "";

  return (
    <MainPageSection>
      {ip ? (
        <>
          <div className="banner-container">
            <div className="banner-heading">
              <h2>
                <FormattedMessage id="YourIpText" />
              </h2>
              <Box display="flex" alignItems="center" justifyContent="center" gap={3}>
                <Tooltip
                  label={intl.formatMessage({ id: "clickToCopy" })}
                  placement="bottom"
                  hasArrow
                  arrowSize={10}
                >
                  <Heading
                    size="2xl"
                    className="ip-address-text"
                    style={{ display: "inline", cursor: "pointer" }}
                    onClick={() => {
                      navigator.clipboard.writeText(ip);
                      toast();
                    }}
                  >
                    {ip}
                  </Heading>
                </Tooltip>
                {flagCode && (
                  <img
                    src={`/flags/${flagCode}.svg`}
                    width="40px"
                    height="30px"
                    alt={countryCode}
                    style={{ borderRadius: "4px" }}
                  />
                )}
              </Box>
            </div>
          </div>
          <UserBannerInfo />
        </>
      ) : (
        <LoaderSpinner />
      )}
    </MainPageSection>
  );
};

export default UserInfoBanner;
